import React from 'react';
import { useSelector } from 'react-redux';
import BookmarkDetailsOcr from './bookmark-details-ocr';
import RenderPolygonBasedStatementDetails from 'utils/ocr-statement-details-utils';
import { useLocation } from 'react-router-dom';
import { ROUTE_CONSTANTS } from 'constants/util/route-constants';
import { ELEMENT_SELECT_MODES } from 'constants/feature/modes-constants';
import { useDispatch } from 'react-redux';
import {
  toggleFormulaCancelModal,
  openSectionPanelAfterCancelConfirmAction,
  storeSelectedSectionIdAction,
  toggleInternalReferenceCancelModal,
} from 'store/actions/panel-cancel-modal-actions';
import { onSectionClick } from 'store/actions/statement-content-actions';

const BookmarksDetailsContainerOCR = ({
  bookmarksList,
  scale,
  dpi,
  leftSideView,
  sectionId,
}) => {
  const pathName = useLocation().pathname;
  const dispatch = useDispatch();

  const {
    data: {
      projectUsersList,
      sectionPanel: {
        sectionReviewList: sectionReview,
        sectionAssignmentsList: sectionAssignments,
      },
      leftStatementContent: { leftSectionReviewsList: leftSectionReview },

      statementSummary: {
        statementSummaryElementsDisplay: {
          displayElementDetailsOnStatementPage,
        },
      },
    },
    ui: {
      statementPage: {
        selectedSectionsMap,
        modes: {
          selectMode: { id: selectModeId },
        },
      },
    },
  } = useSelector((state) => state);

  const isSideBySideView = pathName.includes(ROUTE_CONSTANTS.SIDE_BY_SIDE);
  const { selectedSection, section } = useSelector((store) => {
    const selectedSection =
      isSideBySideView && leftSideView
        ? store.data.leftStatementContent.leftSelectedSection[sectionId]
        : store.ui.statementPage.selectedSectionsMap[sectionId];

    const contentSectionMap =
      isSideBySideView && leftSideView
        ? store.data.leftStatementContent.leftSectionsCache
            .leftContentSectionMap
        : store.data.statementContent.sectionsCache.contentSectionMap;
    return {
      selectedSection,
      section:
        contentSectionMap.map &&
        contentSectionMap.map[sectionId] &&
        Object.values(contentSectionMap.map[sectionId]).find(
          (entry) => entry.sectionId === sectionId,
        ),
    };
  });

  const handleElementClick = (sectionId, bookmarkId) => {
    if (isSideBySideView) {
      return () => {};
    } else {
      if (selectModeId === ELEMENT_SELECT_MODES.FORMULA.id) {
        dispatch(toggleFormulaCancelModal(true));
        dispatch(storeSelectedSectionIdAction(sectionId));
        dispatch(openSectionPanelAfterCancelConfirmAction(true));
      } else if (selectModeId === ELEMENT_SELECT_MODES.INTERNAL_REFERENCE.id) {
        dispatch(toggleInternalReferenceCancelModal(true));
        dispatch(storeSelectedSectionIdAction(sectionId));
        dispatch(openSectionPanelAfterCancelConfirmAction(true));
      } else {
        dispatch(
          onSectionClick({
            sectionId,
            sectionClick: true,
            bookmarkId,
          }),
        );
      }
    }
  };

  const pageBookmarks = [];

  bookmarksList &&
    !!bookmarksList.length &&
    bookmarksList.map((bookmark) => {
      if (!bookmark.deleted) {
        const { polygon } = bookmark;

        pageBookmarks.push(
          <RenderPolygonBasedStatementDetails
            coordinates={polygon}
            scale={scale * dpi}
            key={bookmark.id}
            loopCount={0} // loopcount is set to 0 to show icon for the first bookmark in case of multi-line bookmark scenario.
            displayIcon={true}
          >
            <BookmarkDetailsOcr
              bookmark={bookmark}
              leftSideView={leftSideView}
              isSideBySideView={isSideBySideView}
              shouldSectionAnchorDisabled={
                isSideBySideView
                  ? !leftSideView
                  : leftSideView
              }
              handleElementClick={handleElementClick}
              section={section}
              sectionId={sectionId}
              sectionReview={leftSideView ? leftSectionReview : sectionReview}
              sectionAssignments={sectionAssignments}
              color={
                selectedSectionsMap?.[sectionId]?.bookmarkId === bookmark.id
                  ? selectedSectionsMap?.[sectionId]?.color
                  : null
              }
              displayElementDetailsOnStatementPage={
                displayElementDetailsOnStatementPage
              }
              bookmarkId={bookmark.id}
              selectedSection={selectedSection}
              projectUsersList={projectUsersList}
            />
          </RenderPolygonBasedStatementDetails>,
        );
      }
    });

  return <>{pageBookmarks}</>;
};

export default BookmarksDetailsContainerOCR;
